export const CRM_BASE_URL = 'ui/crm/chat/token';

export const crmQueryKeys = {
  hubspotConversationsToken: ['hubspot-conversations-token'],
};
